module.exports = __webpack_public_path__ + "img/saven_potentiel_picto.149f8a5e.png";